/** Decodifica payload JWT sem verificar assinatura (só UI / claims locais). */

export type JwtClaims = {
  sub?: string;
  email?: string;
  name?: string;
  given_name?: string;
  family_name?: string;
  "cognito:username"?: string;
  "cognito:groups"?: string[];
  "custom:tenant_id"?: string;
  tenant_id?: string;
  exp?: number;
  [key: string]: unknown;
};

export function parseJwtPayload(token: string): JwtClaims | null {
  const parts = token.split(".");
  if (parts.length < 2) return null;
  try {
    const b64 = parts[1]!.replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64.padEnd(b64.length + ((4 - (b64.length % 4)) % 4), "=");
    const json = atob(padded);
    return JSON.parse(json) as JwtClaims;
  } catch {
    return null;
  }
}

export function displayNameFromClaims(claims: JwtClaims): string {
  if (claims.name && typeof claims.name === "string") return claims.name;
  const given = typeof claims.given_name === "string" ? claims.given_name : "";
  const family = typeof claims.family_name === "string" ? claims.family_name : "";
  const full = `${given} ${family}`.trim();
  if (full) return full;
  if (claims.email) return claims.email.split("@")[0] ?? claims.email;
  return claims["cognito:username"] ?? claims.sub ?? "Usuário";
}

export function tenantIdFromClaims(claims: JwtClaims): string | null {
  const custom = claims["custom:tenant_id"];
  if (typeof custom === "string" && custom.length > 0) return custom;
  const plain = claims.tenant_id;
  if (typeof plain === "string" && plain.length > 0) return plain;

  // Supabase Auth: app_metadata.tenant_id (seed homolog / D-037)
  const appMeta =
    claims.app_metadata && typeof claims.app_metadata === "object"
      ? (claims.app_metadata as Record<string, unknown>)
      : null;
  const fromApp = appMeta?.tenant_id;
  if (typeof fromApp === "string" && fromApp.length > 0) return fromApp;

  return null;
}
